module.exports = __webpack_public_path__ + "img/thumbnail_MuteSwan_j_leucistic.1de44236.png";